import axios from "axios";
import { useEffect, useState } from "react";
import Badge from "./Badge";
import Certification from "./Certification";

interface userIdProps {
  userId: string;
}

interface BadgeCertificateStatus {
  subject: string;
  badge: string;
  certificates: string;
  name1: string;
  name2: string;
  name3: string;
  count: number;
  rate: number;
}

interface ResponseData {
  [key: string]: {
    badge: string;
    certificates: string;
    name1: string;
    name2: string;
    name3: string;
    count: number;
    rate: number;
  };
}

const Qualification: React.FC<userIdProps> = ({ userId }) => {
  const [qualification, setQualification] = useState<BadgeCertificateStatus[]>(
    []
  );
  const [error, setError] = useState("");
  const [hoveredSubject, setHoveredSubject] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<ResponseData>(
          `https://chamstudyland.com/api/fun_learning/get_qualification.php?id=${userId}`
        );
        const interativeData: BadgeCertificateStatus[] = Object.entries(
          response.data
        ).map(([key, value]) => ({
          subject: key,
          badge: value.badge,
          certificates: value.certificates,
          name1: value.name1,
          name2: value.name2,
          name3: value.name3,
          count: value.count,
          rate: value.rate,
        }));
        setQualification(interativeData);
      } catch {
        setError("데이터를 가져오는데 실패했습니다.");
      }
    };
    fetchData();
  }, [userId]);

  return (
    <div>
      {/* 뱃지 */}
      <div className="flex flex-col max-w-lg p-3 mx-auto text-center text-gray-900 bg-white border border-gray-100 rounded-lg shadow dark:border-gray-600 dark:bg-gray-800 dark:text-white">
        <h3 className="text-2xl font-semibold">뱃지</h3>
        <p className="font-light text-gray-500 text-sm dark:text-gray-400 mb-3">
          한개의 단어장의 챕터에서 500단어 이상 학습시 뱃지를 획득합니다.
          1000단어 이상 학습시 분홍뱃지를 획득합니다. 5000단어 이상 학습시
          황금뱃지를 획득합니다.
        </p>

        <div>
          {qualification.length === 0 ? (
            <div className="dark:text-slate-200 font-bold text-slate-800 text-xl max-w-sm mx-auto">
              한번도 학습을 한 적이 없습니다
            </div>
          ) : (
            <div className="flex flex-wrap gap-3">
              {qualification.map((item) => (
                <div
                  key={item.subject}
                  onMouseEnter={() => setHoveredSubject(item.subject)}
                  onMouseLeave={() => setHoveredSubject(null)}
                  className="relative"
                >
                  <Badge
                    subject={item.subject}
                    badge={item.badge}
                    name1={item.name1}
                    name2={item.name2}
                    name3={item.name3}
                    count={item.count}
                    rate={item.rate}
                  />
                  {hoveredSubject === item.subject && (
                    <div className="absolute bg-gray-700 text-white text-sm px-2 py-1 rounded-lg -top-8 left-1/2 transform -translate-x-1/2 w-16">
                      단어수 {item.count}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {/* 수료증 */}
      <div className="flex flex-col max-w-lg p-1 mx-auto text-center mt-1 text-gray-900 bg-white border border-gray-100 rounded-lg shadow dark:border-gray-600 dark:bg-gray-800 dark:text-white">
        <h3 className="text-2xl font-semibold">수료증</h3>
        <p className="font-light text-gray-500 text-sm dark:text-gray-400 mb-3">
          한개의 단어장의 챕터에서 500단어 이상 학습하고 정답률이 90%가 넘어가면
          수료증이 발급됩니다.
        </p>

        <div>
          {qualification.length === 0 ? (
            <div className="dark:text-slate-200 font-bold text-slate-800 text-xl max-w-sm mx-auto ">
              한번도 학습을 한 적이 없습니다
            </div>
          ) : (
            qualification.map((item) => (
              <div key={item.subject}>
                <Certification
                  subject={item.subject}
                  certificates={item.certificates}
                  name1={item.name1}
                  name2={item.name2}
                  name3={item.name3}
                  count={item.count}
                  rate={item.rate}
                />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Qualification;
